<div class="container flex flex-col max-w-2xl px-4 py-8 mx-auto">
    <div class="flex flex-col justify-center w-full mb-8 text-center">
        <h1 class="mb-2 text-4xl font-semibold tracking-wide md:text-5xl text-slate-800">Frequently Asked Questions</h1>
    </div>

    <div
        class="flex flex-col gap-4 p-6 mb-8 bg-white border border-gray-100 shadow-sm lg:flex-row lg:items-end rounded-xl"
    >
        <div class="flex-1">
            <input
                id="search"
                type="text"
                [(ngModel)]="searchTerm"
                placeholder="Search FAQs"
                class="box-border w-full p-2 text-sm transition-all border-2 rounded-lg outline-none border-slate-300 text-slate-700 hover:border-primary focus:border-primary"
            />
        </div>
        <div class="flex-1 lg:max-w-sm">
            <app-combo-box
                [options]="categoryOptions"
                [(ngModel)]="selectedCategory"
                (selectionChange)="onCategorySelect($event)"
                placeholder="Select Category"
                [searchable]="true"
                [clearable]="true"
                class="w-full"
            ></app-combo-box>
        </div>
    </div>

    <div class="mb-8">
        <app-accordion [items]="filteredItems" [openAllOnInit]="true"></app-accordion>
    </div>

    <div class="text-center">
        <div class="p-8 bg-white border border-gray-100 shadow-sm rounded-xl">
            <h3 class="mb-3 text-xl font-semibold text-gray-900">Still have questions?</h3>
            <p class="mb-6 text-gray-600">Can't find what you're looking for? Our support team is here to help.</p>
            <a
                href="#"
                class="inline-flex items-center px-6 py-3 font-medium text-white transition rounded-lg bg-secondary hover:bg-secondary-80"
            >
                Contact Support
            </a>
        </div>
    </div>
</div>
